/*
 * @Author: 邓鹏
 * @Date: 2026-04-22 10:11:15
 * @LastEditors: 邓鹏
 * @LastEditTime: 2026-07-07 17:38:37
 * @FilePath: /marketing-landing-fe/src/const/uagwUserId.ts
 * @Description:
 */
export var X_UAGW_USER_ID = '200911671';